import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ContactPageModule } from '@app/contact-page/contact-page.module';
import { SharedModule } from '@app/shared/shared.module';
import { VideosModule } from '@app/videos/videos.module';
import { ContactTabsComponent } from './contact-tabs.component';

@NgModule({
  declarations: [ContactTabsComponent],
  imports: [CommonModule, SharedModule, ContactPageModule, VideosModule],
})
export class ContactTabsModule {}
